




















































































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { RealworksCredentials } from '@/api/model/credentials'
import { RealworksCredentialsAPI, RealworksProductAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'
import { RealworksProduct } from '@/api/model/realworks-product'
import { v4 as uuid } from 'uuid'
import { ProductCategory } from '@/api/model/product-category'

@Component
export default class EditRealworksCredentialsForm extends Vue {
    @Prop({ required: true }) readonly value!: RealworksCredentials
    validating: boolean = false
    showError: boolean = false
    autoConfiguring: boolean = false
    realworksProductIds: RealworksProduct[] = []
    loadingProducts: boolean = false

    async mounted() {
        await this.loadProducts()
    }

    @Watch('value.canRequestFacturen')
    async loadProducts() {
        if (!this.value.canRequestFacturen || !this.companyHasOrdersEnabled) {
            return
        }

        this.loadingProducts = true
        this.realworksProductIds = await RealworksProductAPI.getAll({ company: this.$currentCompany.id })
        this.loadingProducts = false
    }

    async addProductCategory(): Promise<void> {
        this.value.productCategories.push({
            realworksCredentials: this.value.resourceIdentifier,
            id: uuid(),
            name: '',
            realworksProductIds: [],
        })
    }

    async removeProductCategory(productCategory: ProductCategory): Promise<void> {
        if (!confirm('Weet je zeker dat je deze categorie wilt verwijderen?')) {
            return
        }

        const index = this.value.productCategories.findIndex(v => v.id === productCategory.id)
        if (index !== -1) {
            this.value.productCategories.splice(index, 1)
        }
    }

    filteredProducts(category: ProductCategory) {
        return this.realworksProductIds.map(product => ({
            label: product.omschrijving,
            value: product.realworksId,
        }))
            .sort((a, b) => a.label.localeCompare(b.label))
            .filter(product => !this.usedProductIds.includes(product.value) || category.realworksProductIds.includes(product.value))
    }

    async autoConfig(): Promise<void> {
        try {
            this.autoConfiguring = true
            const results = await RealworksCredentialsAPI.validate(this.value)
            this.value.canRequestFacturen = results.facturen
            this.value.canRequestObjecten = results.objecten
            this.value.canRequestAgenda = results.agenda
            this.value.canRequestTaken = results.taken
            this.value.canRequestRelaties = results.relaties
            this.autoConfiguring = false

        } catch (error) {
            this.autoConfiguring = false
        }
    }

    async validatePermission(permission: string): Promise<boolean> {
        try {
            this.validating = true
            const results = await RealworksCredentialsAPI.validate(this.value)
            const result = results[permission]

            if (result === false) {
                this.showError = true
                setTimeout(() => this.showError = false, 4000)
            }

            this.validating = false
            return results[permission]

        } catch (error) {
            console.error(error)
            this.showError = true
            this.validating = false
            setTimeout(() => this.showError = false, 4000)
            return false
        }
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    @Watch('value.canRequestFacturen')
    async onCanRequestFacturenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('facturen')
        if (canActivate === false) {
            this.value.canRequestFacturen = false
        }
    }

    @Watch('value.canRequestObjecten')
    async onCanRequestObjectenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('objecten')
        if (canActivate === false) {
            this.value.canRequestObjecten = false
        }
    }

    @Watch('value.canRequestAgenda')
    async onCanRequestAgendaChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('agenda')
        if (canActivate === false) {
            this.value.canRequestAgenda = false
        }
    }

    @Watch('value.canRequestTaken')
    async onCanRequestTakenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('taken')
        if (canActivate === false) {
            this.value.canRequestTaken = false
        }
    }

    @Watch('value.canRequestRelaties')
    async onCanRequestRelatiesChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('relaties')
        if (canActivate === false) {
            this.value.canRequestRelaties = false
        }
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get isAgendaEnabled(): boolean {
        return this.value?.canRequestAgenda === true
    }

    get isObjectEnabled(): boolean {
        return this.value?.canRequestObjecten === true
    }

    get companyHasOrdersEnabled() {
        return this.$currentCompany?.orderSettings?.enabled || false
    }

    get usedProductIds(): ProductCategory['realworksProductIds'] {
        return this.value.productCategories.flatMap(productCategory => productCategory.realworksProductIds)
    }
}
